export default "__VITE_ASSET__ce2d4418__"